import './About.scss';

function About() {
  return (
    <>
      <div id="about" className="about">
        <h2 className="about__heading">About Relax Massage Surrey</h2>
        <p className="about__copy">
          At Relax Massage Surrey, we specialize in providing top-quality
          massage services tailored to your needs, in the comfort of your
          own home or at our Surrey location.
        </p>
        <p className="about__copy">
          Our team of experienced masseuses are trained in a variety of Asian
          massage techniques, bringing centuries-old healing practices directly
          to your doorstep. Our skilled therapists are dedicated to enhancing
          your well-being through the power of touch.
        </p>
        <p className="about__copy">
          What sets us apart is our commitment to providing care and attention
          to each client. Weather you're seeking relief from muscle tension,
          stress reduction, or simply a moment of relaxation, our masseuses will
          work with you to create a customized treatment plan.
        </p>
        <p className="about__copy">
          We understand the importance of effective communication, which is why
          our masseuses are fluent in both <b>Mandarin</b> and <b>English</b>{" "}
          Ensuring your session is conducted with clarity and understanding,
          allowing you to relax and enjoy the therapeutic benefits of our
          services.
        </p>
        <p className="about__copy">
          <a href="#contact">Book</a> your appointment today and discover the difference that{" "}
          <b>Relax Massage Surrey</b> can make in your well-being
        </p>
      </div>
    </>
  );
}

export default About;
